module.exports = __webpack_public_path__ + "img/refill.4b053ee1.png";